/**
 * Client-side analytics bootstrap (Google Analytics 4 + Microsoft Clarity).
 *
 * Runs from the bundled app (same-origin 'self'), so it needs no CSP
 * inline-script allowance -- only the external GA/Clarity hosts are
 * whitelisted in the control-plane CSP. IDs are injected at build time via
 * Vite `import.meta.env.VITE_*`; absent IDs make this a no-op (pre-launch /
 * non-configured environments stay clean).
 */
export function initAnalytics(): void {
    const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID;
    const clarityId = import.meta.env.VITE_CLARITY_PROJECT_ID;

    if (gaId) {
        const s = document.createElement('script');
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
        document.head.appendChild(s);
        window.dataLayer = window.dataLayer || [];
        // gtag pushes its own arguments object onto the dataLayer.
        function gtag(...args: unknown[]) {
            window.dataLayer.push(args);
        }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', gaId);
    }

    if (clarityId) {
        type ClarityFunction = ((...args: unknown[]) => void) & { q?: unknown[][] };

        (function (c: Window & Record<string, ClarityFunction | undefined>, l: Document, a: string, r: string, i: string) {
            c[a] = c[a] || function (...args: unknown[]) {
                (c[a]!.q = c[a]!.q || []).push(args);
            };
            const t = l.createElement(r) as HTMLScriptElement;
            t.async = true;
            t.src = `https://www.clarity.ms/tag/${i}`;
            const y = l.getElementsByTagName(r)[0];
            y.parentNode!.insertBefore(t, y);
        })(window as unknown as Window & Record<string, ClarityFunction | undefined>, document, 'clarity', 'script', clarityId);
    }
}
